{
  "name": "admin",
  "version": "1.2.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "buildDev": "ng build --configuration development",
    "buildStage": "ng build --configuration staging",
    "buildRadiology": "ng build --configuration productionRadiology",
    "buildDefault": "ng build --configuration default",
    "buildDoctorDev": "ng build --configuration developmentDoctor",
    "buildDoctorStage": "ng build --configuration stagingDoctor",
    "buildDoctorProd": "ng build --configuration productionDoctor",
    "buildRadiologyDev": "ng build --configuration developmentRadiology",
    "buildRadiologyStage": "ng build --configuration stagingRadiology",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.19",
    "@angular/cdk": "^20.0.0",
    "@angular/common": "^20.3.19",
    "@angular/compiler": "^20.3.19",
    "@angular/core": "^20.3.19",
    "@angular/forms": "^20.3.19",
    "@angular/google-maps": "^20.1.6",
    "@angular/localize": "^20.3.19",
    "@angular/material": "^20.0.0",
    "@angular/material-moment-adapter": "^20.0.0",
    "@angular/platform-browser": "^20.3.19",
    "@angular/platform-browser-dynamic": "^20.3.19",
    "@angular/router": "^20.3.19",
    "@progress/kendo-angular-buttons": "^19.3.0",
    "@progress/kendo-angular-charts": "^19.3.0",
    "@progress/kendo-angular-common": "^19.3.0",
    "@progress/kendo-angular-conversational-ui": "^19.3.0",
    "@progress/kendo-angular-dateinputs": "^19.3.0",
    "@progress/kendo-angular-dialog": "^19.3.0",
    "@progress/kendo-angular-dropdowns": "^19.3.0",
    "@progress/kendo-angular-editor": "^19.3.0",
    "@progress/kendo-angular-excel-export": "^19.3.0",
    "@progress/kendo-angular-grid": "^19.3.0",
    "@progress/kendo-angular-icons": "^19.3.0",
    "@progress/kendo-angular-indicators": "^19.3.0",
    "@progress/kendo-angular-inputs": "^19.3.0",
    "@progress/kendo-angular-intl": "^19.3.0",
    "@progress/kendo-angular-l10n": "^19.3.0",
    "@progress/kendo-angular-label": "^19.3.0",
    "@progress/kendo-angular-layout": "^19.3.0",
    "@progress/kendo-angular-menu": "^19.3.0",
    "@progress/kendo-angular-navigation": "^19.3.0",
    "@progress/kendo-angular-pager": "^19.3.0",
    "@progress/kendo-angular-pdf-export": "^19.3.0",
    "@progress/kendo-angular-popup": "^19.3.0",
    "@progress/kendo-angular-progressbar": "^19.3.0",
    "@progress/kendo-angular-toolbar": "^19.3.0",
    "@progress/kendo-angular-treeview": "^19.3.0",
    "@progress/kendo-angular-utils": "^19.3.0",
    "@progress/kendo-charts": "^2.12.2",
    "@progress/kendo-data-query": "^1.7.4",
    "@progress/kendo-drawing": "^1.25.1",
    "@progress/kendo-licensing": "^1.11.1",
    "@progress/kendo-theme-default": "^14.0.0",
    "bootstrap": "^5.2.3",
    "crypto-js": "^4.2.0",
    "hammerjs": "^2.0.8",
    "jquery": "^3.6.1",
    "moment": "^2.30.1",
    "ngx-pagination": "^6.0.3",
    "ngx-toastr": "^18.0.0",
    "rxjs": "~7.5.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.25",
    "@angular/cli": "~20.3.25",
    "@angular/compiler-cli": "^20.3.19",
    "@types/crypto-js": "^4.2.2",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "~4.0.0",
    "@types/node": "^20.10.0",
    "jasmine-core": "~4.3.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~5.8.3"
  }
}